<script setup lang="ts">

defineProps<{
  groupName: string;
  countdown: number;
}>();
</script>

<template>
  <Dialog
    :close-on-escape="false"
    :modal="true"
    :show-header="false"
    :pt="{
      root: {
        class: 'relative flex items-center justify-center w-auto mx-auto h-auto'
      },
      content: {
        class: 'rounded-xl'
      }
    }
    "
  >
    <div class="flex flex-col p-4 gap-2">
      <div class="mb-3 flex justify-center">
        <img
          src="@images/gifs/confetti.gif"
          alt="Success"
          class="w-[120px] h-[120px]"
        >
      </div>
      <div class="text-22 font-bold text-center mb-2">
        Welcome to the group!
      </div>
      <div class="text-16 text-neutral-70 text-center">
        You're now a member of {{groupName}}
      </div>
    </div>
    <Badge
      v-if="countdown"
      :value="Math.trunc(countdown) + 1"
      class="absolute -right-2 -top-2"
    />
  </Dialog>
</template>